<app-all-warehouse-product-list
  [competitionWzObject]="competitionWzObject"
  [dialogRef]="dialogRef"
></app-all-warehouse-product-list>
